<div class="header-wrapper" [ngClass]="{'header-wrapper__impersonated': impersonateService.impersonatedUser}">
  <img [routerLink]="['/']" src="../../../assets/img/app-logo.png" />
  <div>
    <!-- chat -->
    <ng-container>
      <i class="bi bi-chat" [ngClass]="{ 'hide-chat': impersonateService.impersonatedUser }" (click)="toggleChatPanel()"></i>
      <span *ngIf="chatService.activeChats.length > 0" class="notification-count notification-count--chat" [ngClass]="{ 'hide-chat': impersonateService.impersonatedUser }">
        {{ chatService.activeChats.length }}
      </span>
    </ng-container>
    <!-- notifications -->
    <ng-container>
      <i class="bi bi-bell" (click)="toggleNotificationsPanel()"></i>
      <span *ngIf="unreadCount > 0" class="notification-count">{{ unreadCount }}</span>
    </ng-container>
  </div>
</div>

<div class="profile-info-container">
  <app-impersonate-info *ngIf="impersonateService.impersonatedUser"
    [userName]="impersonateService.impersonatedUser.fullName" [userEmail]="impersonateService.impersonatedUser.email"
    (backToProfile)="stopImpersonation()" class="mx-auto">
  </app-impersonate-info>
</div>

<app-notifications-panel [isOpen]="isNotificationPanelOpen" (close)="closeNotificationsPanel()">
</app-notifications-panel>

<app-chat-panel [isOpen]="isChatPanelOpen" (close)="closeChatPanel()">
</app-chat-panel>
